import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import adore from "../Assets/Brands/adore.png";
import cbella from "../Assets/Brands/c-bella.png";
import celena from "../Assets/Brands/celena.png";
import dahab from "../Assets/Brands/dahab.png";
import desio from "../Assets/Brands/desio.png";
import lazord from "../Assets/Brands/lazord.png";
import lereve from "../Assets/Brands/lereve.png";
import lorans from "../Assets/Brands/lorans.png";
import luminous from "../Assets/Brands/luminous.png";
import lydia from "../Assets/Brands/lydia.png";
import magiccolor from "../Assets/Brands/magiccolor.png";
import naturel from "../Assets/Brands/naturel.png";
import alcon from "../Assets/Brands/brand-alcon.png";
import biomed from "../Assets/Brands/brand-biomed.png";
import johnson from "../Assets/Brands/brand-johnson.png";
import bl from "../Assets/Brands/brand-bl.png";


const partners = [
  { src: adore,      name: 'Adore',              categorySlug: 'colored-lenses', subCategoryId: '69d0721a68659c2e081b4b6d' },
  { src: cbella,     name: 'C-Bella',             categorySlug: 'colored-lenses', subCategoryId: '69d0721768659c2e081b4b62' },
  { src: celena,     name: 'Celena',              categorySlug: 'colored-lenses', subCategoryId: '69d0722a68659c2e081b4bae' },
  { src: dahab,      name: 'Dahab',               categorySlug: 'colored-lenses', subCategoryId: '69d0721a68659c2e081b4b71' },
  { src: desio,      name: 'Desio',               categorySlug: 'colored-lenses', subCategoryId: '69d0721d68659c2e081b4b7c' },
  { src: lazord,     name: 'Lazord',              categorySlug: 'colored-lenses', subCategoryId: '69d0722768659c2e081b4ba2' },
  { src: lereve,     name: 'Le Reve',             categorySlug: 'colored-lenses', subCategoryId: '69d0721e68659c2e081b4b81' },
  { src: lorans,     name: 'Lorans',              categorySlug: 'colored-lenses', subCategoryId: '69d0722168659c2e081b4b8d' },
  { src: luminous,   name: 'Luminous',            categorySlug: 'colored-lenses', subCategoryId: '69d0722368659c2e081b4b95' },
  { src: lydia,      name: 'Lydia',               categorySlug: 'colored-lenses', subCategoryId: '69d0721b68659c2e081b4b74' },
  { src: magiccolor, name: 'Magic Color',         categorySlug: 'colored-lenses', subCategoryId: '69d0721968659c2e081b4b69' },
  { src: naturel,    name: 'Naturel',             categorySlug: 'colored-lenses', subCategoryId: '69d0721568659c2e081b4b5b' },
  { src: alcon,      name: 'Alcon',               categorySlug: 'clear-lenses',   subCategoryId: '69d0729c68659c2e081b4d38' },
  { src: biomed,     name: 'Biomed',              categorySlug: 'clear-lenses',   subCategoryId: null },
  { src: johnson,    name: 'Johnson & Johnson',   categorySlug: 'clear-lenses',   subCategoryId: '69d0729e68659c2e081b4d41' },
  { src: bl,         name: 'Bausch & Lomb',       categorySlug: 'clear-lenses',   subCategoryId: '69d0729c68659c2e081b4d3b' },
];

const PartnersCarousel = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(7); // Default value for large screens
  const length = partners.length;
  const timeoutRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  
  const delay = 1500;

  useEffect(() => {
    const getSlidesToShow = () => {
      if (window.innerWidth < 520) return 3;
      if (window.innerWidth < 768) return 4;
      return 8; // Default number of slides for larger screens
    };

    // Set initial slides to show based on screen size
    setSlidesToShow(getSlidesToShow());

    const handleResize = () => {
      setSlidesToShow(getSlidesToShow());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isPaused) return;

    const nextSlide = () => {
      setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
    };

    timeoutRef.current = setTimeout(nextSlide, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [current, isPaused, length]);

  const handleMouseEnter = () => {
    setIsPaused(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  // Function to create the "cloned" slides
  const clonedPartners = [...partners, ...partners.slice(0, slidesToShow)];

  return (
    <div className="container mx-auto px-4 py-12">
      <div
        className="relative overflow-hidden"
        style={{ zIndex: 1 }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{
            transform: `translateX(-${(current * 100) / clonedPartners.length}%)`,
            width: `${(clonedPartners.length * 100) / slidesToShow}%`
          }}
        >
          {clonedPartners.map((partner, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-full px-2 cursor-pointer"
              style={{ width: `${100 / clonedPartners.length}%` }}
              onClick={() => navigate(`/products/${partner.categorySlug}`, {
                state: partner.subCategoryId
                  ? { initialBrand: { id: partner.subCategoryId, name: partner.name } }
                  : undefined,
              })}
            >
              <img
                src={partner.src}
                alt={partner.name}
                onError={(e) => { e.target.style.opacity = '0'; }}
                className="w-full h-16 sm:h-20 md:h-24 object-contain mx-auto grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersCarousel;
